import React from 'react';

import { Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import LoadingSpinner from '../LoadingSpinner';

class NPSpinnerModal extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            showModal: true,
        };
    }

    render() {

        const { showModal, useInternalState, isLoading, content, title, closeAction } = this.props;
        const show = useInternalState ? this.state.showModal && showModal : showModal;

        return (
            <Modal show={show} onHide={() => { this.setState({ showModal: false }); closeAction && closeAction(); }}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    {!isLoading && content}
                    {isLoading && <LoadingSpinner isLoading={true} />}
                </Modal.Body>
            </Modal>
        )
    }
}

export default NPSpinnerModal;